import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FarmProvider } from 'src/app/providers/farm.provider';
import { MilkingControlProvider } from 'src/app/providers/milking-control.provider';
import { MilkingProvider } from 'src/app/providers/milking.provider';
import { MilkingAlertsEnum } from 'src/app/schemes/enums/milking.enum';
import { AssociationModel } from 'src/app/schemes/models/association.model';
import { FarmModel } from 'src/app/schemes/models/farm.model';
import { MilkingModel } from 'src/app/schemes/models/milking.model';
import { AssociationService } from 'src/app/services/association.service';
import { FarmService } from 'src/app/services/farm.service';
import { TimeService } from 'src/app/services/time.service';
import ngPrimeLocale from '../../../../../assets/locale/ngprime.json';

@Component({
	selector: 'app-filter-milkings-modal',
	templateUrl: './filter-milkings-modal.component.html',
	styleUrls: ['./filter-milkings-modal.component.scss'],
})
export class FilterMilkingsModalComponent implements OnInit {
	es = ngPrimeLocale;
	association: AssociationModel = {} as AssociationModel;
	currentFarm: FarmModel = {} as FarmModel;
	filteredControls: { name: string; _id: string }[];
	filteredFarms: { name: string; _id: string }[];
	controls: { name: string; _id: string }[];
	farms: { name: string; _id: string }[];
	alerts: { name: string; _id: string }[];
	methods: { name: string; _id: string }[] = [];
	filters: { [key in keyof MilkingModel]?: any } = {};
	urlToNavigate: string = '';
	indexedControls: {
		[key: string]: {
			name: string;
			value: string;
		};
	};

	constructor(
		private milkingProvider: MilkingProvider,
		private milkingControlProvider: MilkingControlProvider,
		private farmProvider: FarmProvider,
		public dialogRef: MatDialogRef<FilterMilkingsModalComponent>,
		private router: Router,
		private datePipe: DatePipe,
		private associationService: AssociationService,
		private farmService: FarmService,

		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.filters = {
			officialId: null,
			control: null,
			farm: null,
			method: null,
			controlDate: {
				start: null,
				end: null,
			},
		};
	}

	async ngOnInit(): Promise<void> {
		try {
			this.association = await this.associationService.getCurrentAssociation();
			this.currentFarm = await this.farmService.getCurrentFarm();
			await this.setControls();
			await this.setFarms();
			await this.setAlerts();
			await this.setMethods();
			this.urlToNavigate = this.data.url;
			this.setFiltersValues(this.data);
		} catch (error) {
			console.error(error);
		}
	}

	async setControls(): Promise<void> {
		const controlsData = (await this.milkingControlProvider.getAll({ _show: 'code, date, farmName' })).data;
		this.controls = controlsData.map(control => ({
			name: `${control.code} - ${control.farmName} - ${this.datePipe.transform(control.date, 'dd/MM/yyyy')}`,
			_id: control._id,
		}));
		this.filteredControls = this.controls;
	}

	async setFarms(): Promise<void> {
		const farmsData = (await this.farmProvider.getAll({ _show: 'name' })).data;
		this.farms = farmsData.map(farm => ({ name: farm.name, _id: farm._id }));
		if (this.currentFarm) {
			this.farms = this.farms.filter(farm => farm._id === this.currentFarm._id);
		}
		this.filteredFarms = this.farms;
	}

	async setAlerts(): Promise<void> {
		const alertsData = MilkingAlertsEnum;
		this.alerts = Object.keys(alertsData).map(alert => ({
			name: `${alert} - ${alertsData[alert]}`,
			_id: alert,
		}));
	}

	async setMethods(): Promise<void> {
		const methodsData = this.association.config?.milkingData?.milkingMethods || [];
		this.methods = methodsData.map(method => ({ name: method, _id: method }));
	}

	searchControl($event) {
		this.filteredControls = this.controls.filter(
			control => control.name.toLowerCase().indexOf($event.query.toString().toLowerCase()) !== -1
		);
	}

	setFiltersValues(data) {
		if (data.filters) {
			if (data.filters.officialId_like) this.filters.officialId = data.filters.officialId_like;
			if (data.filters.control_in) {
				const prevFilterControls: {}[] = [];
				data.filters.control_in = data.filters.control_in.split(',');
				this.filters.control = data.filters.control_in.forEach(controlData =>
					this.controls.find(control => {
						if (control._id === controlData) {
							prevFilterControls.push(control);
						}
						return null;
					})
				);
				this.filters.control = prevFilterControls;
			}
			if (data.filters.farm_in) {
				const prevFilterFarms: {}[] = [];
				data.filters.farm_in = data.filters.farm_in.split(',');
				this.filters.farm = data.filters.farm_in.forEach(farmData =>
					this.farms.find(farm => {
						if (farm._id === farmData) {
							prevFilterFarms.push(farm);
						}
						return null;
					})
				);
				this.filters.farm = prevFilterFarms;
			}

			if (data.filters.method_in) {
				const prevFilterMethods: {}[] = [];
				data.filters.method_in = data.filters.method_in.split(',');
				this.filters.method = data.filters.method_in.map(methodData =>
					this.methods.find(method => {
						if (method._id === methodData) {
							prevFilterMethods.push(method);
						}
						return null; // Add a return statement here
					})
				);
				this.filters.method = prevFilterMethods;
			}

			if (data.filters.controlDate_gte) {
				this.filters.controlDate.start = TimeService.parseDate(data.filters.controlDate_gte);
			}

			if (data.filters.controlDate_lte) {
				this.filters.controlDate.end = TimeService.parseDate(data.filters.controlDate_lte);
			}

			if (data.filters.alerts_in) {
				data.filters.alerts_in = data.filters.alerts_in.split(',');
				this.filters.alerts = data.filters.alerts_in.map(alertData =>
					this.alerts.find(alert => {
						if (alert._id === alertData) {
							return alert;
						}
						return null;
					})
				);
			}
			// 	this.filters.control = Object.keys(this.controls)
			// 		.filter(key => key.includes('_id'))
			// 		.some(key => this.controls[key] === data.filter.control_in);
		}
	}

	parseFilters(filters: Object) {
		return Object.entries(filters).reduce((newFilters, [key, value]) => {
			if (!value) {
				return newFilters;
			}
			if (key.toLowerCase().includes('date')) {
				if (value.start) newFilters[`${key}_gte`] = value.start;
				if (value.end) {
					newFilters[`${key}_lte`] = value.end;
					newFilters[`${key}_lte`];
				}
			} else if (typeof value === 'string') {
				newFilters[`${key}_like`] = value;
			} else if (Array(value) && value.length > 0) {
				newFilters[`${key}_in`] = value.map(val => val._id).join(',') || '';
			} else {
				if (typeof value === 'object') {
					for (const val in value) {
						newFilters[`${key}.${val}_like`] = filters[key][val];
					}
				}
				if (!value.value) {
					return newFilters;
				}
				newFilters[`${key}`] = value.value;
			}
			return newFilters;
		}, {});
	}

	public onSaveFilters(): void {
		const urlFilters = this.parseFilters(this.filters);
		this.dialogRef.close(urlFilters);
		this.router.navigate([this.urlToNavigate], { queryParams: urlFilters });
	}

	public onClearFilters(): void {
		this.filters = {
			officialId: null,
			control: null,
			farm: null,
			method: null,
			controlDate: {
				start: null,
				end: null,
			},
		};
	}
}
